import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import Home from "./routes/Home";
import { useWallet } from "./wallet-context";
import NewEngagement from './routes/NewEngagement';
import Collection from './routes/Collection';
import Graph from './routes/Graph';
import Sign from './routes/Sign';

const WalletGuard = (props: React.PropsWithChildren<{}>) => {
  const { web3 } = useWallet();
  const { location, push } = useHistory();
  useEffect(() => {
    if (!web3) {
      // push("/wallet-connect");
    }
  }, [web3, location, push]);
  return <>{props.children}</>;
};

const AppRouter: React.FC = () => {
  return (
    <Router>
      <WalletGuard>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/new" exact>
            <NewEngagement />
          </Route>
          <Route path="/collection" exact>
            <Collection />
          </Route>
          <Route path="/graph" exact>
            <Graph />
          </Route>
          <Route path="/sign/:ipfshash/:signature" exact>
            <Sign />
          </Route>
        </Switch>
      </WalletGuard>
    </Router>
  );
};

export default AppRouter;
